module.exports = __webpack_public_path__ + "static/media/nowl.2472c246.png";